import { FilterBar } from "./FilterBar";
import { FilterBeach } from "./FilterBeach";
import { FilterGolf } from "./FilterGolf";
import { FilterGym } from "./FilterGym";
import { FilterHospital } from "./FilterHospital";
import { FilterMall } from "./FilterMall";
import { FilterSS } from "./FilterSS";
import { FilterSchool } from "./FilterSchool";
import { FilterShop } from "./FilterShop";
import { FilterTennis } from "./FilterTennis";

export const FILTER_ICONS = {
  FilterBar,
  FilterBeach,
  FilterGolf,
  FilterGym,
  FilterHospital,
  FilterMall,
  FilterSS,
  FilterSchool,
  FilterShop,
  FilterTennis,
};
